<template>
    <div>
        <TheLoaderComponent v-if="showLoader || !details" :local="true"></TheLoaderComponent>
        <div v-else>
            <div v-if="details" class="mb-5 col-md-6 card-model-description">
                <div v-if="lang === 'ar-sa'" v-html="shortDescription(details.description['ar-sa'])"></div>
                <div v-else v-html="shortDescription(details.description['en'])"></div>
            </div>

            <div class="col-12">
                <div class="model-description color position-relative d-flex flex-column flex-md-row">
                    <p class="my-auto ">{{ this.btns.chooseColor }}</p>
                    <ul class="d-flex">
                        <li class="js-show-color show-color" v-model="colorModel" @click="addColor($event, color)"
                            v-for="color in (details && details.material.colors)"
                            :style="{ backgroundColor: color }"></li>
                    </ul>
                </div>

                <div v-if="details.custom_field">
                    <div v-for="(field, index) in details.custom_field" :key="index" class="custom-fields">
                        <div v-if="field.field_type === '1'" class="">
                            <label :for="'custom_field_input_' + index">{{ field.field_name }}</label>
                            <input :name="'custom_field_input_' + index" type="text" v-model="field.value"
                                   :maxlength="field.character_limit"
                                   :placeholder="`Max `+ field.character_limit +` Characters`">

                        </div>
                        <div v-if="field.field_type === '3'" class="">
                            <label :for="'custom_field_input_' + index">{{ field.field_name }}</label>
                            <v-select
                                :name="'custom_field_input_' + index"
                                :id="'custom_field_input_' + index"
                                @input="onCustomFieldChange"
                                v-model="selectedField"
                                :options="field.options"
                                label="selected-option"
                                :clearable="false"
                                required
                            >
                                <template slot="option" slot-scope="option">
                                    {{ option.option }} <span class="additional-price">+{{ option.additional_price }} SAR</span>
                                </template>
                                <template slot="selected-option" slot-scope="selectedOption">
                                    <span>{{ selectedOption.option }}</span> <span class="additional-price">+{{
                                        selectedOption.additional_price
                                    }} {{ lang === 'ar-sa' ? 'ر.س' : 'SAR' }}</span>
                                </template>
                            </v-select>


                        </div>
                        <div v-if="field.field_type === '2'" class="d-flex">
                            <p class="my-auto">{{ field.field_name }}</p>
                            <div class="custom-upload-container">
                                <label class="my-auto" :for="'custom_field_input_' + index">
                                    Upload File <img src="../../../../../public/images/icons/upload.svg" class="ms-3"
                                                     alt="">
                                </label>
                                <input accept=".jpg, .jpeg, .png, .pdf" class="my-auto custom-upload"
                                       :name="'custom_field_input_' + index" type="file"
                                       @change="uploadPhoto($event, field.field_name)">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-flex mt-5">
                <div class="d-flex show-model_full-price ">
                    <p class="my-auto">{{ btns.price }}</p>
                    <h2 v-if="details" class="show-model_caluclate-full-price ms-3 me-0">{{ originalPrice }}
                        <span class="ms-1 me-0">{{ lang === 'ar-sa' ? 'ر.س' : 'SAR' }}</span>
                        <span class="inclusive-vat">{{
                                lang === 'ar-sa' ? 'شامل الضريبة المضافة' : 'Inclusive of VAT'
                            }}</span>
                    </h2>
                </div>
                <div class="quantity h-auto d-flex align-items-center p-0 ms-auto me-0">
                    <button class="js-minus-btn minus-btn" type="button" @click="calculate('minus', details.price)"
                            name="button">
                        <i class="fa-solid fa-minus"></i>
                    </button>

                    <input v-if="details" type="text" class="m-0 show-count" name="name" :data-price="originalPrice"
                           value="1">
                    <input type="hidden" name="type" data-type="" value="">

                    <button class="js-plus-btn plus-btn" @click="calculate('plus', details.price)" type="button"
                            name="button">
                        <i class="fa-solid fa-plus"></i>
                    </button>

                </div>


            </div>
            <div class="col-12 d-flex flex-column flex-md-row align-items-md-center show-model__price ">

                <div class="d-flex flex-column flex-md-row mt-5 mt-md-0 align-items-center detail-like__block">
                    <button class="btn-purple w-100 mb-3 mb-md-0 btn js-add-to-cart me-md-4 ms-0 h-auto btn-adaptive"
                            @click="addToCart($event)" style="width: 185px;">{{ btns.addToCart }}
                    </button>
                    <div class="d-flex align-items-center align-self-start align-self-md-auto">
                        <div :class="{ 'd-none': showLike }"
                             class="like__block mx-5 d-flex justify-content-center align-items-center">
                            <img
                                :src="details.liked ? '/images/icons/icon-like-full.svg' : '/images/icons/icon-like.svg'"
                                class="add-cart-icon " alt="like"
                                @click="changeLikesStatus($event, details)" style="cursor: pointer">
                        </div>
                        <img src="../../../../../public/images/icons/icon-lable.svg" class="add-cart-icon" alt="cart"
                             @click="createWishlist($event, details)" style="cursor: pointer">

                        <div class="dropdown" @click="toggleDropdown">
                            <img src="../../../../../public/images/icons/icon-share.svg" class="add-cart-icon mx-4"
                                 alt="share"
                                 style="cursor: pointer">
                            <ul v-if="isDropdownOpen" class="dropdown-menu share__dropdown d-block"
                                style="font-size: 14px; left: 50px">
                                <li><a @click="shareOnFacebook" class="d-flex"><img
                                    src="../../../../../public/images/icons/square-facebook.svg" alt="">Facebook</a>
                                </li>
                                <li><a @click="shareOnTwitter()" class="d-flex"><img
                                    src="../../../../../public/images/icons/square-x-twitter.svg" alt="">Twitter (X)</a>
                                </li>
                                <li><a @click="shareOnWhatsApp()" class="d-flex"><img
                                    src="../../../../../public/images/icons/icon-whatsapp.svg" alt="">WhatsUp</a></li>
                                <li><a @click="copyLink()" class="d-flex"><img
                                    src="../../../../../public/images/icons/copy-link.svg" alt="">Copy Link</a></li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
            <div class="col-12 d-flex mt-5">
                <div class="model-statistics d-flex">
                    <img src="../../../../../public/images/icons/heart.svg" alt="">
                    <p v-if="statistic != null">{{ statistic.likes }}</p>
                </div>
                <div class="model-statistics d-flex">
                    <img src="../../../../../public/images/icons/eye.svg" alt="">
                    <p v-if="statistic != null">{{ statistic.views }}</p>
                </div>
                <div class="model-statistics d-flex">
                    <img src="../../../../../public/images/icons/Frame.svg" alt="">
                    <p v-if="statistic != null">{{ statistic.prints }}</p>
                </div>
            </div>
        </div>
    </div>

</template>

<script type="application/javascript">
import TheLoaderComponent from "./../TheLoaderComponent";

export default {
    components: {
        TheLoaderComponent,
    },
    name: "DetailsModelComponent",
    props: ['auth'],

    data() {
        return {
            customFields: {},
            selectedField: null,
            truePrice: 0,
            originalPrice: 0,
            isDropdownOpen: false,
            statusWishListItem: true,
            showLoader: false,
            arrSlugs: [],
            arrayObjModelToCart: [],
            details: null,
            colorModel: null,
            statistic: null,
            likeStatus: false,
            showLike: this.auth != 1,
            breadCrumbs: {
                home: '',
                gallery: '',
                activePage: '',
            },
            btns: {
                share: '',
                adToCart: '',
                chooseColor: '',
                price: ''
            },
            statisticTitle: {
                likes: '',
                views: '',
                prints: '',
            },
            detailsTitle: {
                category: '',
                material: '',
                description: ''
            },
            lang: window.currentlang,
            countWishList: []

        }
    },

    mounted() {
        this.getDataModel();
    },

    updated() {
        let vm = this
        vm.arrayObjModelToCart = JSON.parse(localStorage.getItem(`cart-basic-${userId}`));
        // this.visitStatistic()

        let liLang = document.querySelectorAll('.js-change-lang li')
        this.changeContent()
    },

    methods: {

        uploadPhoto(e, fieldName) {
            const file = e.target.files[0];
            const data = new FormData();
            data.append('image', file);


            axios.post('/gallery/upload', data)
                .then(response => {
                    this.customFields['field2'] = {
                        title: fieldName,
                        value: response.data.filePath
                    };

                })
                .catch(error => {
                    console.log(error);
                });
        },
        onCustomFieldChange(price) {
            let priceCurrency = '';
            if(this.lang === 'ar-sa') {
                priceCurrency = 'ر.س';
            } else {
                priceCurrency = 'SAR'
            }
            if(this.selectedField !== null) {
                let modelPrice = this.selectedField.additional_price;
                let fullPrice = document.querySelector('.show-model_caluclate-full-price');

                if(modelPrice === null) {
                    this.originalPrice = this.truePrice;
                    fullPrice.textContent = this.truePrice + ' ' + priceCurrency;
                } else {
                    const additionalPrice = parseFloat(modelPrice);
                    if(!isNaN(modelPrice)) {
                        this.originalPrice = this.truePrice;
                        this.originalPrice = (parseFloat(this.originalPrice) + additionalPrice).toFixed(2);
                        fullPrice.textContent = this.originalPrice + ' ' + priceCurrency;
                    }
                }
            }
        },
        shortDescription(text) {
            if(!text) return '';
            const sentences = text.split('. ');
            if(sentences.length > 0) {
                return sentences[0] + '.';
            } else {
                return text;
            }
        },
        shareOnWhatsApp() {
            const shareUrl = 'whatsapp://send?text=' + encodeURIComponent(window.location.href);
            window.open(shareUrl, '_blank')
        },
        shareOnTwitter() {
            const shareUrl = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(window.location.href);
            window.open(shareUrl, '_blank');
        },
        shareOnFacebook() {
            const shareUrl = 'https://www.facebook.com/sharer.php?u=' + encodeURIComponent(window.location.href);
            window.open(shareUrl, '_blank');
        },
        copyLink() {
            const input = document.createElement('input');
            input.style.position = 'absolute';
            input.style.left = '-9999px';
            input.value = window.location.href;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
        createWishlist(e, product) {
            if(this.auth == 0) {
                window.location.href = '/sigh-in';
                return;
            }
            let vm = this
            let iconCounts = document.querySelectorAll('.js-count-items')

            let countWishInLocal = parseInt(iconCounts[0].textContent);
            if(countWishInLocal !== vm.countWishList.length) {
                axios.get(`/wishlist/items`).then(function (response) {
                    vm.countWishList = response.data['data'][0]['models'];
                    iconCounts.forEach(count => {
                        count.textContent = vm.countWishList.length
                    })
                    localStorage.setItem('itemCount', vm.countWishList.length)
                });
            }
            let flagIsInWish = false;
            vm.countWishList.forEach((wishProduct) => {
                if(product.id === wishProduct.id) {
                    flagIsInWish = true;
                }
            });
            //if new wish -> add to db
            if(!flagIsInWish) {
                let data = {
                    user_id: userId,
                    model_id: product.id
                }
                axios.post(`/wishlist/store/${product.id}`, data).then(function (response) {
                    vm.countWishList.push(product)

                    iconCounts.forEach(count => {
                        count.textContent = vm.countWishList.length
                    })
                    e.target.src = '/images/icon-lable-full.svg';

                    localStorage.setItem('itemCount', vm.countWishList.length)

                    window.notify(window.getTranslationText("This model added to favorites"), "success");
                }).catch(function (error) {
                    window.notify(window.getTranslationText("This model not added to wishlist"), "error");
                })
            }
        },
        changeContent() {
            if(window.currentLang === 'ar-sa') {
                this.lang = 'ar-sa'
                this.details.title.length > 50 ? this.title = this.details.title['ar-sa'].substring(0, 47) + "..." : this.title = this.details.title['ar-sa']
                this.breadCrumbs.home = 'الرئيسية'
                this.breadCrumbs.gallery = 'معرض النماذج والمنتجات'
                this.breadCrumbs.activePage = 'صفحة المنتج:'

                this.btns.share = 'مشاركة'
                this.btns.addToCart = 'أضف إلى السلة'
                this.btns.chooseColor = 'اختر اللون'
                this.btns.price = 'السعر'

                this.statisticTitle.likes = 'الإعجابات'
                this.statisticTitle.views = 'المشاهدات'
                this.statisticTitle.prints = 'الطبعات'

                this.detailsTitle.category = 'الفئة'
                this.detailsTitle.material = 'نوع المادة'
                this.detailsTitle.description = 'وصف المنتج'

            } else {
                this.lang = 'en'
                this.details.title.length > 50 ? this.title = this.details.title['en'].substring(0, 47) + "..." : this.title = this.details.title['en']

                this.detailsTitle.category = 'Category'
                this.detailsTitle.material = 'Material'
                this.detailsTitle.description = '3D Model description'

                this.statisticTitle.likes = 'Total likes'
                this.statisticTitle.views = 'Total views'
                this.statisticTitle.prints = 'Total Prints'

                this.btns.share = 'Share'
                this.btns.addToCart = 'Add to cart'
                this.btns.chooseColor = 'Choose Color'
                this.btns.price = 'Price'


                this.breadCrumbs.home = 'Home'
                this.breadCrumbs.gallery = 'Gallery'
                this.breadCrumbs.activePage = 'Product Page:'
            }
        },
        addColor(event, color) {
            let vm = this
            vm.colorModel = color
            let listColors = document.querySelectorAll('.js-show-color')

            listColors.forEach(list => {
                // list.classList.remove('border-danger', 'border')
                list.style.outline = '0px solid black';
            })

            // event.target.classList.add('border-danger', 'border')
            event.target.style.outline = '6px solid white';

            vm.colorModel = color
        },
        getDataModel() {
            let href = location.href
            let vm = this
            let idModel = href.split('/').pop();

            axios.get(`/gallery/data/${idModel}?statistic=true`).then(function (responce) {
                let data = responce.data.data
                vm.details = data
                vm.originalPrice = data.price
                vm.truePrice = data.price
                vm.statistic = data.statistic
                vm.likeStatus = data.liked
                if(vm.details.custom_field) {
                    for (let i = 0; i < vm.details.custom_field.length; i++) {
                        if(vm.details.custom_field[i].field_type === '3' && vm.details.custom_field[i].options) {


                            vm.selectedField = vm.details.custom_field[i].options[0];
                            // this.originalPrice = this.truePrice;
                            // this.originalPrice = (parseFloat(this.originalPrice) + vm.selectedField.additional_price).toFixed(2);
                            // fullPrice.textContent = this.originalPrice + ' SAR';

                        }
                    }
                }
            }).finally(() => {
                vm.visitStatistic();
                vm.onCustomFieldChange();
            })


        },
        changeLikesStatus(event, product) {
            let vm = this
            let parentId = vm.details.id
            let url = !event.target.classList.contains('fa-solid') ? `/${parentId}/like` : `/${parentId}/unlike`
            event.target.classList.toggle('fa-solid')
            if(event.target.classList.contains('fa-solid')) {
                event.target.src = '/images/icons/icon-like-full.svg';
            } else {
                event.target.src = '/images/icons/icon-like.svg';
            }

            axios.post(url).then(function (response) {
            })

            // if (event.target.classList.contains('fa-solid')) {
            //     vm.createWishlist(product)
            // }
        },
        calculate(action, price) {
            let vm = this
            let count = document.querySelector('.show-count')
            let fullPrice = document.querySelector('.show-model_caluclate-full-price')
            let calculatePrice = null

            let priceCurrency = '';
            if(this.lang === 'ar-sa') {
                priceCurrency = 'ر.س';
            } else {
                priceCurrency = 'SAR'
            }
            let currentValue = +count.value;


            if(action === 'plus') {
                calculatePrice = (currentValue + 1) * +count.getAttribute('data-price');
            } else if(action === 'minus' && currentValue > 0) {
                calculatePrice = (currentValue - 1) * count.getAttribute('data-price');
            } else if(action === 'change') {
                calculatePrice = currentValue * +count.getAttribute('data-price');
            }

            if(calculatePrice < price) {
                fullPrice.textContent = price.toFixed(2) + " " + priceCurrency;
            } else {
                fullPrice.textContent = calculatePrice.toFixed(2) + " " + priceCurrency;
            }


        },

        visitStatistic() {
            let vm = this
            let id = vm.details.id
            axios.post(`/gallery/${id}/visit`).then(function (response) {
            })
        },
        addToCart(event) {
            let vm = this
            let parent = event.currentTarget.closest('.detail-block')
            // let price = parent.querySelector('.show-model_caluclate-full-price').textContent
            let price = vm.originalPrice;
            let count = +parent.querySelector('.show-count').value
            let cartIcon = document.querySelectorAll('.fa-cart-shopping')
            let selectedColor = vm.colorModel
            if(selectedColor === undefined || selectedColor === null) {
                selectedColor = vm.details.material.colors[0]
            }
            if(vm.details.custom_field) {
                vm.details.custom_field.forEach((field) => {
                    if(field.field_type === '3') {
                        vm.customFields[`field3`] = {
                            title: field.field_name,
                            value: vm.selectedField,
                        };
                    }
                    if(field.field_type === '1') {
                        vm.customFields[`field1`] = {
                            title: field.field_name,
                            value: field.value,
                        };

                    }
                });
            }


            let objModelInfo = {
                id: vm.details.id,
                name: vm.details.title,
                img: vm.details.img,
                description: vm.details.title,
                price: +price.replace('ر.س', ' '),
                priceCalculate: +price.replace('ر.س', ' '),
                count,
                type: "App\\Models\\Model\\Model",
                color: selectedColor,
                material: vm.details && vm.details.material.name,
                category: vm.details && vm.details.categories,
                colors: vm.details.material.colors,
                customFields: vm.customFields,
            }
            if(vm.details.file_hash !== undefined) {
                objModelInfo.file_size = vm.details.file_size;
                objModelInfo.file_hash = vm.details.file_hash;
                objModelInfo.dynamic_img = '/storage/models_dynamic_mp4/' + vm.details.file_hash + '_' + vm.details.file_size + '_' + vm.details.color.replace('#', '') + '.mp4';
                objModelInfo.mouseover = false;
            }
            vm.arrayObjModelToCart = []

            //get cart
            JSON.parse(localStorage.getItem(`cart-basic-${userId}`)) && JSON.parse(localStorage.getItem(`cart-basic-${userId}`)).forEach(item => {
                vm.arrayObjModelToCart.push(item)
            })

            let flagInCartSelectedColor = false
            vm.arrayObjModelToCart.forEach((productInCart) => {
                if(productInCart.id === vm.details.id && productInCart.color === objModelInfo.color) {
                    productInCart.count += count;
                    productInCart.priceCalculate = productInCart.price * productInCart.count;
                    flagInCartSelectedColor = true;
                }
            });
            if(!flagInCartSelectedColor) {
                vm.arrayObjModelToCart.push(objModelInfo)
            }

            //saving
            localStorage.setItem(`cart-basic-${userId}`, JSON.stringify(vm.arrayObjModelToCart));
            vm.arrayObjModelToCart = JSON.parse(localStorage.getItem(`cart-basic-${userId}`));
            cartIcon.forEach(item => {
                (vm.arrayObjModelToCart && vm.arrayObjModelToCart.length !== 0) && item.classList.remove('d-none')
            })

            if(localStorage.getItem('lang') === 'ar-sa') {
                window.notify('تمت الإضافة إلى السلة', 'success')

            } else {
                window.notify('Added to cart', 'success')
            }
            updateCartCount();
        },
        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
        },
    },
}
</script>
